import { useEffect, useState } from 'react';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

interface UserNameDisplay {
    ID?: number;
    userName?: string;
    userEmail?: string;
    userPicture?: string;
}

interface UserNameItemProps {
    user: UserNameDisplay;
    setShowUserCard?: ((userId: number) => void) | null;
    /** Компактний вигляд: менший аватар, лише ім'я */
    smallMode?: boolean;
    /** Замінює email. Показується і в smallMode. */
    description?: string;
}

const UserNameItem = ({
    user,
    setShowUserCard = null,
    smallMode = false,
    description,
}: UserNameItemProps) => {
    const [src, setSrc] = useState(user?.userPicture || '/imgs/user.png');

    useEffect(() => {
        setSrc(user?.userPicture || '/imgs/user.png');
    }, [user?.userPicture]);

    return (
        <Row
            className={[
                'w-100 m-0 flex-nowrap align-items-center',
                smallMode ? 'user-name-item--small' : undefined,
            ]
                .filter(Boolean)
                .join(' ')}
        >
            <Col className="px-0 flex-shrink-0" xs="auto">
                <img
                    className={[
                        'awatar awatar-user rounded-circle',
                        smallMode ? 'awatar--small' : undefined,
                    ]
                        .filter(Boolean)
                        .join(' ')}
                    src={src}
                    alt=""
                    onError={() => {
                        setSrc('/imgs/user.png');
                    }}
                />
            </Col>
            <Col className="min-w-0 overflow-hidden">
                <div
                    className={`${setShowUserCard ? 'cursor-pointer' : ''} text-truncate`}
                    onClick={() => (setShowUserCard && user.ID ? setShowUserCard(user.ID) : null)}
                >
                    {smallMode && user?.userEmail ? (
                        <OverlayTrigger placement="top" overlay={<Tooltip>{user.userEmail}</Tooltip>}>
                            <h6 className="d-inline-block mw-100 text-truncate mb-0 user-name-item__name--small">
                                {user?.userName}
                            </h6>
                        </OverlayTrigger>
                    ) : (
                        <h6
                            className={[
                                'text-truncate',
                                smallMode ? 'mb-0 user-name-item__name--small' : 'mb-1',
                            ].join(' ')}
                            title={user?.userName || user?.userEmail}
                        >
                            {user?.userName}
                        </h6>
                    )}
                    {description !== undefined ? (
                        description ? (
                            <p className="text-muted f-12 mb-0 text-truncate" title={description}>
                                {description}
                            </p>
                        ) : null
                    ) : !smallMode ? (
                        <p className="text-muted f-12 mb-0 text-truncate" title={user?.userEmail}>
                            {user?.userEmail}
                        </p>
                    ) : null}
                </div>
            </Col>
        </Row>
    );
};

export default UserNameItem;
